'use strict';

var formValidation = require('../components/formValidation');
var addressBook = require('base/addressBook/addressBook');
const { customCountrySelector } = require('../customCountrySelector');
const isStageShipping = window.location.href.includes('stage=shipping');
const isStagePayment = window.location.href.includes('stage=payment');

//Biba-int country-state mapping
if(isStageShipping || isStagePayment || document.querySelector('.custom-search-select') || document.querySelector('.address-add') || document.querySelector('.btn-show-details') || document.querySelector('.btn-add-new') ) {
    var customStateSelect = require('../customStateSelect');

    if(isStageShipping || isStagePayment) {
        customStateSelect && customStateSelect.initCustomStateSelect('.shipping-section');
    } 
}


var url;
var isDefault;

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.error-messaging').append(errorHtml);
}
function removeAddress() {
    $(document).on('click' , '.remove-address' ,function (e) {
        e.preventDefault();
        isDefault = $(this).data('default');
        if (isDefault) {
            url = $(this).attr('href')
                + '&isDefault='
                + isDefault;
        } else {
            url = $(this).attr('href');
        }
        $('#removeAddress .btn-primary').attr('href', url);
        $('.product-to-remove').empty().append($(this).data('id'));
        $("#removeAddress").modal('show');
    });
};

function submitAddress() {
    $(document).on('submit' , 'form.address-form' ,function (e) {
        var $form = $(this).closest('form');
        e.preventDefault();
        url = $form.attr('action');
        $form.spinner().start();
        $('form.address-form').trigger('address:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if(data.error && data.redirectUrl) {
                    location.href = data.redirectUrl;
                }
                if (!data.success) {
                    formValidation($form, data);
                } else {
                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $form.spinner().stop();
            }
        });
        $form.closest('modal').removeClass('show').removeAttr('style');
        return false;
    });
};

function removeAddressConfirmation() {
    $(document).on('click', '.delete-confirmation-btn', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                location.reload();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
        $(this).closest('modal').removeClass('show').removeAttr('style');
    });
};
function makeAddressDefault() {
    $(document).on('change', '.makeDefaultAddress .custom-control-input', function (e) {
        if( $(this).closest('.address-card') &&  $(this).is(':checked')){
            $('#address-make-default .btn-primary').attr('href', $(this).closest('.makeDefaultAddress').data('url'));
            $("#address-make-default").modal('show');
        } 
    });
};
    
const customAddress = () => {
    makeAddressDefault();
    removeAddressConfirmation(); 
    submitAddress();
    removeAddress();

    $(document).on('bs.modal.show', '#address-lineItem-modal', function() {
        customCountrySelector();
        customStateSelect && customStateSelect.initCustomStateSelect('#address-lineItem-modal');
    });

    $(document).on('click', '.address-add, .address-edit, .shipping-address-add, .shipping-address-edit', function (e) {
        e.preventDefault();
        var element = $(this);
        $.spinner().start();
            $.ajax({
            url: $(this).attr('href'), 
            success: function(result){
                $("#address-lineItem-modal").find('.modal-body').html( $(result).find('.address-form') );
                $("#address-lineItem-modal .modal-title").text( $(result).find('.address-form').data('form') );
                setTimeout(function() {
                    customCountrySelector();
                    $.spinner().stop();
                    if( element.closest('.address-card').length && !element.closest('.address-card').find('.remove-address').length ){
                        $("#address-lineItem-modal").find('.custom-control-label').trigger('click');
                    }
                    $("#address-lineItem-modal").modal('show');

                    customStateSelect && customStateSelect.initCustomStateSelect('#address-lineItem-modal');
                }, 500);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).on('change', '.changeShippingJS', function () {
        var curr = this.id;
        $('.change-address-modal').removeClass('activeAddress');
        $(this).closest('.change-address-modal').addClass('activeAddress');
        var submitButton = $('.changeAddressSubmitButton');
        submitButton.removeClass('disabled');
        var url = submitButton.attr('data-url').split('?')[0];
        submitButton.attr('data-url', `${url}?addressId=${curr}`);
    });

    $(document).on('shown.bs.modal', '#changeAddressModal', function () {
        $(this).find('.changeShippingJS').first().attr('checked', true)
            .trigger('change');
    });

    $(document).on('click', '.changeAddressSubmitButton', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            url: url,
            success: function(result){
                window.location.href = result.redirectUrl;
            },
            error: function (result) {
                if (result.error) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).on('click', '.btn-add-new', function(e) {
        e.preventDefault();
        $("#editAddressModal").find('.modal-body').empty();
        var dataSaveUrl = $(this).data('saveurl');
        $.spinner().start();
            $.ajax({
            url: $(this).data('url'), 
            success: function(data){
                $("#editAddressModal").find('.modal-body').append('<form name="editAddressForm" id="editAddressForm" novalidate action="'+dataSaveUrl+'" class="editAddressForm address-form" method="get">');
                $("#editAddressModal").find('form.editAddressForm').html(data);
                $("#editAddressModal").find('.modal-body').append('</form>');
                $("#editAddressModal").find('.modal-header .modal-title.editAddressModalTitle').addClass('d-none');
                $("#editAddressModal").find('.modal-header .modal-title.addAddressModalTitle').removeClass('d-none');
                setTimeout(function() {
                    customCountrySelector();
                    $.spinner().stop();
                    $("#editAddressModal").modal('show');

                    customStateSelect && customStateSelect.initCustomStateSelect('#editAddressModal');
                    try {
                        require('../checkout/placesAutocomplete').init(document.getElementById('editAddressModal'));
                    } catch (err) { }
                }, 500);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $(document).on('click', '.edit-address-button', function (e) {
        e.preventDefault();
        $("#editAddressModal").find('.modal-body').empty();
        var editUrl = $(this).data('url');
        var dataSaveUrl = $(this).data('saveurl');
        $('#changeAddressModal').modal('hide');
        $.spinner().start();
            $.ajax({
            url: editUrl, 
            success: function(data){
                $("#editAddressModal").find('.modal-body').append('<form name="editAddressForm" id="editAddressForm" action="'+dataSaveUrl+'" class="editAddressForm address-form" method="get">');
                $("#editAddressModal").find('form.editAddressForm').html(data);
                $("#editAddressModal").find('.modal-body').append('</form>');
                $("#editAddressModal").find('.modal-header .modal-title.addAddressModalTitle').addClass('d-none');
                $("#editAddressModal").find('.modal-header .modal-title.editAddressModalTitle').removeClass('d-none');
                setTimeout(function() {
                    customCountrySelector();
                    $.spinner().stop();
                    $("#editAddressModal").modal('show');

                    customStateSelect && customStateSelect.initCustomStateSelect('#editAddressModal');
                    try {
                        require('../checkout/placesAutocomplete').init(document.getElementById('editAddressModal'));
                    } catch (err) {  }
                }, 500);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });
}

$(() => {
    customAddress();
});

module.exports = {customAddress};